<script setup>
import FsLightbox from "fslightbox-vue/v3";
import axios from 'axios';
import { onMounted, ref } from 'vue';
const toggler = ref(false);
const sources = ref([]);

// defineProps({
//     responsibility: Object
// });

const responsibility = ref([]);

async function getSocialResponsibility() {
    try {
        const res = await axios.get('/get-all-social-responsibility-data');
        responsibility.value = res.data || [];
    } catch (error) {
        console.error('Error fetching :', error);
    }
}

onMounted(() => {
    getSocialResponsibility();
})

const openLightbox = (image) => {
    sources.value = [image];
    toggler.value = !toggler.value;
};

</script>
<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 xl:pt-8 pt-4 xl:pb-12 pb-4 mx-auto">
            <div class="pb-4 wow animate__animated animate__fadeInLeft">
                <h2
                    class="text-center text-black leading-tight mx-auto font-roboto title-font xl:text-[44px] lg:text-[36px] sm:text-[28px] text-xl lg:mt-4 sm:mb-6 mb-4">
                    {{ $t("home.social_work") }}</h2>
                <div class="mx-auto border-[3.5px] border-transparent border-t-[#1cbed1] w-36"></div>
            </div>






            <div class="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-4 lg:mt-8 mt-4 xl:mb-12 mb-8 cursor-pointer">
                <div class="group overflow-hidden wow animate__animated animate__fadeInLeft"
                    @click="openLightbox(response.image)" v-for="response in responsibility" :key="response.id">
                    <div class="relative block overflow-hidden w-full xl:h-[340px] sm:h-[250px] h-full">
                        <VLazyImage :src="response?.image" :alt="response?.title" class="w-full h-full object-cover" />
                        <div
                            class="absolute inset-0 bg-black bg-opacity-40 text-center top-0 left-0 gap-2 opacity-0 group-hover:opacity-100 transition duration-300 h-full w-full">

                            <div class="absolute top-[45%] xl:left-[48%] lg:left-[44%] left-[40%] text-center mx-auto">

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-9 h-9 text-white">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6" />
                                </svg>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
    <FsLightbox :toggler="toggler" :sources="sources" />
</template>
<style scoped></style>
